export default "/assets/images/turn-on-mila-app.png?e6cd9ce177703f35577832e948e8b9bd";